import React, { Component } from 'react';
import firebase from 'firebase';
import { is } from 'date-fns/locale';
import { Pulse } from 'react-preloading-component';

class Disponibilidad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            valueT: undefined,
            valueB: undefined,
            viajes: [],
            baseS: 'indice',
            tipoS: 'indice',
            empleados: [],
            bases: [],
            vehiculos: [],
            tipoV: [],
            isLoading: true
        }
    }

    cargarData = () => {
        firebase.database().ref('Bases').once('value').then(snap => {
            let bases = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                bases.push(datos);
            });
            this.setState({ bases })
        });
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
            let tipoV = [];
            snap.forEach(element => {
                let data = element.val();
                tipoV.push(data);
            });
            this.setState({ tipoV, isLoading: false })
        })
    }

    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        firebase.database().ref('Bases').once('value').then(snap => {
            let bases = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                bases.push(datos);
            });
            firebase.database().ref('Empleados').once('value').then(snap2 => {
                let empleados = [];
                snap2.forEach(element => {
                    let data = element.val();
                    data.key = element.key;
                    empleados.push(data);
                });
                firebase.database().ref('Vehiculos').once('value').then(snap3 => {
                    let vehiculos = [];
                    snap3.forEach(element => {
                        let data = element.val();
                        data.key = element.key;
                        vehiculos.push(data);
                    });
                    firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
                        let tipoV = [];
                        snap.forEach(element => {
                            let data = element.val();
                            tipoV.push(data);
                        });
                        this.setState({ empleados, bases, vehiculos, tipoV, isLoading: false })
                        this.getDisponible();
                    })
                })
            })
        })
    }

    handleChangeT = (event) => {
        this.setState({ tipoS: event.target.value, baseS: 'indice' })
        firebase.database().ref('LaboresEmpresa').orderByChild('tipoV').equalTo(event.target.value).once('value').then(snap => {
            this.setState({ viajes: [] })
            snap.forEach(element => {
                let datos = element.val();
                firebase.database().ref('Empleados/' + datos.emple).once('value').then(snap2 => {
                    let datos2 = snap2.val();
                    firebase.database().ref('Bases/' + datos.base).once('value').then(snap3 => {
                        let datos3 = snap3.val();
                        firebase.database().ref('Vehiculos/' + datos2.vehiculo).once('value').then(snap4 => {
                            let datos4 = snap4.val();
                            datos.emple = datos2.nombre;
                            datos.base = datos3.Nombre;
                            datos.vehiculo = datos4.movil;
                            this.setState({ viajes: [...this.state.viajes, datos], isLoading: false })
                        })
                    })
                })
            });
        })
    }
    handleChangeB = (event) => {
        this.setState({ baseS: event.target.value, tipoS: 'indice' })
        firebase.database().ref('LaboresEmpresa').orderByChild('base').equalTo(event.target.value).once('value').then(snap => {
            this.setState({ viajes: [] })
            snap.forEach(element => {
                let datos = element.val();
                firebase.database().ref('Empleados/' + datos.emple).once('value').then(snap2 => {
                    let datos2 = snap2.val();
                    firebase.database().ref('Bases/' + datos.base).once('value').then(snap3 => {
                        let datos3 = snap3.val();
                        firebase.database().ref('Vehiculos/' + datos2.vehiculo).once('value').then(snap4 => {
                            let datos4 = snap4.val();
                            datos.emple = datos2.nombre;
                            datos.base = datos3.Nombre;
                            datos.vehiculo = datos4.movil;
                            this.setState({ viajes: [...this.state.viajes, datos], isLoading: false })
                        })
                    })
                })
            });
        })
    }

    getDisponible = () => {
        firebase.database().ref('/LaboresEmpresa').orderByChild('cooncordancia').on('value', snap => {
            let { empleados, bases, vehiculos, tipoV } = this.state;
            let viajes = [];
            snap.forEach(element => {
                let datos = element.val();
                if (datos.emple !== undefined) {
                    let empleado = empleados.find(v => v.key == datos.emple);
                    let base = bases.find(v => v.key == datos.base);
                    let vehiculo = vehiculos.find(v => v.key == empleado.vehiculo);
                    datos.emple = empleado.nombre;
                    datos.base = base && base.Nombre;
                    datos.vehiculo = vehiculo && vehiculo.movil;
                    viajes.push(datos)
                }
            });
            this.setState({ viajes, isLoading: false })
        })
    }

    render() {
        let { bases, tipoV, viajes, isLoading } = this.state;
        return (
            <div className="container col-11 col-sm-11">
                <div className="form-row align-items-center">
                    <div className="col-sm-1 my-1">
                        <label className="text-gray">Filtros</label>
                    </div>
                    <div className="col-sm-3 my-1">
                        <select defaultValue={this.state.tipoS} onChange={this.handleChangeT} className="form-control bg-select my-1 mr-sm-2">
                            <option value='indice' disabled>Todos los vehículos</option>
                            {tipoV.map((snap, index) => {
                                return (
                                    <option key={'tipod' + index} value={snap.tipo} >{snap.tipo}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col-sm-3 my-1">
                        <select defaultValue={this.state.baseS} onChange={this.handleChangeB} className="form-control bg-select my-1 mr-sm-2">
                            <option value='indice' disabled>Todas las bases</option>
                            {bases.map((snap, index) => {
                                return (
                                    <option key={'basesd' + index} value={snap.key} >{snap.Nombre}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="table-responsive">
                        <table className="table text-center">
                            <thead>
                                <tr>
                                    <th scope="col">Orden</th>
                                    <th scope="col">Base</th>
                                    <th scope="col">Vehículo</th>
                                    <th scope="col">Unidad</th>
                                    <th scope="col">Capacidad</th>
                                    <th scope="col">Conductor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center' }}>
                                            <Pulse />
                                        </td>
                                    </tr>
                                ) : (
                                    viajes.map((snap, index) => {
                                        return (
                                            <tr key={'conten' + index}>
                                                <th scope="row">{snap.cooncordancia}</th>
                                                <td>{snap.base}</td>
                                                <td>{snap.tipoV}</td>
                                                <td>{snap.vehiculo}</td>
                                                <td>4</td>
                                                <td>{snap.emple}</td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}
export default Disponibilidad


// WEBPACK FOOTER //
// ./src/Components/Planificacion/disponibilidad.js